var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_710_23167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6696 1.73806L10.2612 0.329468C9.82178 -0.109985 9.10834 -0.109985 8.66913 0.329468L7.34538 1.65486L10.3243 4.65486L11.6499 3.32947C12.1102 2.88978 12.1102 2.17751 11.6696 1.73806ZM0.727565 8.25228C0.675205 8.30464 0.639534 8.3713 0.624979 8.44391L0.00763532 11.5306C-0.039849 11.7679 0.144346 11.9999 0.373893 11.9999C0.398479 11.9999 0.42351 11.9975 0.44887 11.9924L3.53559 11.3751C3.6082 11.3606 3.67483 11.3249 3.72721 11.2726L9.81393 5.18588L6.81393 2.18588L0.727565 8.25228ZM3.09147 10.3171L1.33038 10.6694L1.68264 8.90806L2.25006 8.34134V9.74994H3.65913L3.09147 10.3171Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_710_23167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.633157abc47ac13c041a45e8185ab5be.svg";
export { ForwardRef as ReactComponent };